module.exports = __webpack_public_path__ + "img/compressed-1976570037020004352.cb5d9cab.png";